export enum ModelName {
  GPT_35_TURBO = "gpt-3-5-turbo",
  GPT_4_TURBO = "gpt-4-turbo",
  GPT_4O = "gpt-4o",
  GPT_4O_MINI = "gpt-4o-mini",
  GPT_41 = "gpt-4.1",
  GPT_41_MINI = "gpt-4.1-mini",
  GPT_41_NANO = "gpt-4.1-nano",
  GPT_5 = "gpt-5",
  GPT_5_MINI = "gpt-5-mini",
  GPT_5_NANO = "gpt-5-nano",
  GPT_54 = "gpt-5.4",
  GPT_54_MINI = "gpt-5.4-mini",
  GPT_54_NANO = "gpt-5.4-nano",
  GPT_55 = "gpt-5.5",
  GPT_56_LUNA = "gpt-5.6-luna",
  GPT_56_TERRA = "gpt-5.6-terra",
  GPT_56_SOL = "gpt-5.6-sol",
  O1_PREVIEW = "o1-preview",
  O1 = "o1",
  O3 = "o3",
  O1_MINI = "o1-mini",
  O3_MINI = "o3-mini",
  O4_MINI = "o4-mini",
  GEMINI_1_5_PRO_002 = "gemini-1.5-pro-002",
  GEMINI_2_0_FLASH = "gemini-2.0-flash",
  GEMINI_2_5_PRO_PREVIEW = "gemini-2.5-pro-preview-05-06",
  GEMINI_2_5_FLASH_PREVIEW = "gemini-2.5-flash-preview-04-17",
  GEMINI_2_5_PRO = "gemini-2.5-pro",
  GEMINI_2_5_FLASH = "gemini-2.5-flash",
  GEMINI_2_5_FLASH_IMAGE = "gemini-2.5-flash-image",
  GEMINI_3_PRO_PREVIEW = "gemini-3-pro-preview",
  GEMINI_3_PRO_IMAGE = "gemini-3-pro-image",
  GEMINI_3_1_FLASH_IMAGE = "gemini-3.1-flash-image",
  GEMINI_3_1_PRO_PREVIEW = "gemini-3.1-pro-preview",
  GEMINI_3_FLASH_PREVIEW = "gemini-3-flash-preview",
  GEMINI_3_5_FLASH = "gemini-3.5-flash",
  GEMINI_3_8_FLASH = "gemini-3.8-flash",
  GEMINI_4_ARGON = "gemini-4-argon",
  CLAUDE_4_SONNET = "claude-sonnet-4@20250514",
  CLAUDE_4_5_SONNET = "claude-sonnet-4-5@20250929",
  CLAUDE_4_6_SONNET = "claude-sonnet-4-6@default",
  CLAUDE_5_SONNET = "claude-sonnet-5@default",
  CLAUDE_4_OPUS = "claude-opus-4@20250514",
  CLAUDE_4_1_OPUS = "claude-opus-4-1@20250805",
  CLAUDE_4_5_OPUS = "claude-opus-4-5@20251101",
  CLAUDE_4_6_OPUS = "claude-opus-4-6@default",
  CLAUDE_4_7_OPUS = "claude-opus-4-7@default",
  CLAUDE_4_8_OPUS = "claude-opus-4-8@default",
  CLAUDE_5_OPUS = "claude-opus-5@default",
  CHEMCROW = "chemcrow",
}
